module.exports = __webpack_public_path__ + "static/media/icon-nav-packaging.5c527eb6.svg";